export default "__VITE_ASSET__BtAWC2HX__"